import { css } from "styled-components";
import { Carousel, CarouselControls, CarouselSlide, CarouselProgressBar, CarouselViewport, CarouselSlides, } from "../../../../components/Carousel";
import { Card, CardDescription, CardTitle, CardImage } from "../../../../components/Card";
import { BladeHeaderCentered } from "../../../../molecules/BladeHeaderCentered";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
  }

  ${BladeHeaderCentered} {
    position: relative;
  }

  ${Carousel} {
    ${CarouselViewport} {
      margin-bottom: ${chroma.spacers.variable.m};

      ${CarouselSlides} {
        display: flex;
        gap: ${chroma.spacers.variable.m};
      }
    }

    &[data-state-all-slides-visible="true"] {
      ${CarouselControls} {
        display: none;
      }
    }

    ${CarouselSlide} {
      --carousel-n-up: 3;
      ${chroma.mediaQueries.tabletDown} {
        --carousel-n-up: 2;
      }
      ${chroma.mediaQueries.mobileDown} {
        --carousel-n-up: 1;
      }

      --carousel-gap: ${chroma.spacers.variable.m};
      --carousel-gap-count: calc(var(--carousel-n-up) - 1);

      min-width: calc(((100% - (var(--carousel-gap) * var(--carousel-gap-count))) / (1 * var(--carousel-n-up))));
    }

    ${CarouselControls} {
      position: relative;
      display: flex;
      justify-content: flex-end;
      gap: ${chroma.spacers.constant.s};

      .trigger-wrapper {
        display: flex;
        gap: ${chroma.spacers.constant.xs};
        align-self: flex-end;

        button {
          margin: 0;
        }
      }

      ${CarouselProgressBar} {
        padding-right: 0;

        .indicator {
          transition: width 0.7s ease-out;
          background-color: ${paletteTokens.accents1};
          height: 4px;
        }

        .rail {
          margin-top: 0;
          width: 100%;
          background-color: ${paletteTokens.keyline};
        }

        flex-grow: 1;
        align-self: center;
        ${chroma.mediaQueries.mobileDown} {
          padding: ${chroma.spacers.variable.m} 0;
          height: 12px;
          width: 100%;
        }
      }
    }
  }

  li {
    > div {
      height: 100%;

      > div {
        height: 100%;
      }
    }
  }

  ${Card} {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    ${CardImage} {
      object-fit: cover;
      background-color: ${paletteTokens.bladebg2};
      margin-bottom: ${chroma.spacers.constant.s};
    }

    .content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: start;
      color: ${paletteTokens.bladetext1};
    }

    ${CardTitle} {
      ${chroma.typography.body2};
      font-weight: bold;
      text-align: center;
      margin-bottom: ${chroma.spacers.constant.xs};
    }

    ${CardDescription} {
      text-align: center;
    }
  }
`;
//# sourceMappingURL=index.js.map